import type { Component } from 'vue';
import Button from 'primevue/button';
import { createApp } from 'vue';

import { getApp } from '@modules/core/app/utils';
import ErrorServiceUnavailable
  from '@modules/error-pages/components/ErrorServiceUnavailable/ErrorServiceUnavailable.vue';

import getQueryClient from '../../core/app/utils/getQueryClient';
import SimpleApp from '../components/SimpleApp/SimpleApp.vue';

export default function createSimpleErrorApp(component: Component = ErrorServiceUnavailable): void {
  const currentApp = getApp();

  if (currentApp._instance?.isMounted) {
    currentApp.unmount();
  }
  void getQueryClient().cancelQueries();

  const app = createApp(SimpleApp);
  app.component('SimpleAppDynamicComponent', component);
  app.component('PButton', Button);

  app.mount('#app');
}
